import { Injectable } from '@angular/core';
import { Lookup } from '@common/utilities/Lookup';
import { ApiService } from './api.service';
import { DataService, UserRecord } from './data.service';
import { SynchronizationService } from './synchronization.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private lookupById = new Lookup<UserRecord>(i => i.ID);

  private _sync(notify = true) {

    if (notify) this.sync.notify(UsersService, false);    

    this.ds.users('list').subscribe(users => {

      if (users) {
        this.lookupById.source = users.filter(i => i.ID > 0).union([{ ID: 0, Username: "Tự động", Password: null, Roles: ['Owner'] }]);
        this.sync.notify(UsersService, true);
      }
      else {
        if (this.api.authorized) {
          this._sync(false);
        }
        else {
          this.api.credentialChanged.subscribe(user => {
            this._sync(false);
          });
        }
      }
    });
  }

  public synchronize() {
    this._sync();
  }

  public get current(): UserRecord {
    return this.get(this.api.user.ID);
  }

  public get(id: number): UserRecord {
    return this.lookupById.get(id, null);
  }

  public get all(): UserRecord[] {
    return this.lookupById.source;
  }

  constructor(private ds: DataService, private api: ApiService, private sync: SynchronizationService) {
    
    this._sync();    
  }
}
